import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Label } from 'reactstrap';
import EditBoxNumber from './EditBoxNumber';
import Toggle from '../../Toggle';
import WarningModal from '../../WarningModal';
import { toast } from 'react-toastify';
import { setPortConfigModalSource } from '../../../actions/EpikBoxes';

const EditBoxNumberModal = ({
  isOpen,
  onConfirm,
  onCancel,
  boxDetails,
  selectRoute,
  gateways,
  onRemoveNumber,
  updatePort,
  type,
  onlyEfax,
  user,
  vmail,
  updateTrunkSelection,
  onTrunckSelection,
  setInbandRouting,
  props,
  testStatusFromStore,
  selectedPort,
  onPortConfigure,
  setPortConfigModalSource,
  boxToBoxHuntInvalid,
}) => {
  const [confirmation, setConfirmation] = useState();
  const [defaultPortConfirmationModal, setDefaultPortConfirmationModal] = useState();
  const [loadingCustom, setLoadingCustom] = useState(false);
  const [portConfigOpenedFromCustom, setPortConfigOpenedFromCustom] = useState(false);
  const needsNewLineType = type === 'fax' && !!onlyEfax;

  const handleSave = () => {
    const { editedNumber } = props;
    if (needsNewLineType) {
      return toast.error('Please select a new line type');
    }
    const isRingDown = editedNumber?.type === 'ringDown';
    const hasNoForwardUris = !editedNumber?.forwardUris?.length;
    if (isRingDown && hasNoForwardUris) {
      return toast.error('Ring down number is required');
    }
    if (selectedPort.DTMFMethod == 'rfc2833' && editedNumber.inbandRouting) {
      return toast.error('please disable inband route before using RFC');
    }
    
    if (testStatusFromStore) {
      setConfirmation({
        ata:
        'This action will reset the port configuration settings and restart the EPI. During the reboot, both ports will be offline for approximately 3 minutes. Do you want to continue?',
      });
      return;
    }
    setConfirmation({
      ata:
      'This action will reset the port configuration settings and restart the EPI. During the reboot, both ports will be offline for approximately 3 minutes. Do you want to continue?',
    });
  }
  
  const onWarningConfirm = ({ defaultPortConfirmationValue = undefined }) => {
  const { recording } = confirmation;
  
  if (recording) {
    setConfirmation({
      recording: '',
      ata:
      'The ATA needs to be rebooted to configure the port and the affected ports will be offline for 3 minutes. Are you sure you want to proceed?',
    });
    return;
  }

  if(!!!selectedPort.appliedConfigTemplate && defaultPortConfirmationValue === undefined){
    setDefaultPortConfirmationModal(true)
    return;
  }

  setConfirmation();
  onConfirm({ useDefaultPortConfig: defaultPortConfirmationValue });
}
  const onDefaultPortResponse = async (value) => {
    // If Custom option is selected (value === false), open Port Configuration modal with loading
    if (value === false && onPortConfigure) {
      // Set Redux state to track that modal is opened from "Custom" button
      if (setPortConfigModalSource) {
        setPortConfigModalSource('customButton');
      }
      
      setLoadingCustom(true);
      setPortConfigOpenedFromCustom(true); // Track that port config was opened from Custom button
      try {
        // Pass callback that will be called when port config Apply succeeds
        await onPortConfigure(true, handlePortConfigSuccess);
        // Keep modal open but hide the warning modal after port config opens
        setDefaultPortConfirmationModal(false);
        setLoadingCustom(false);
      } catch (error) {
        console.error('Error opening port configuration:', error);
        setLoadingCustom(false);
        setPortConfigOpenedFromCustom(false);
      }
      return;
    }
    
    // Otherwise, proceed with the default flow
    onWarningConfirm({defaultPortConfirmationValue: value});
  }
  
  // Callback to handle when port config Apply is successful
  const handlePortConfigSuccess = () => {
    // Proceed with the save flow (what would have happened if Default was selected)
    setPortConfigOpenedFromCustom(false);
    onWarningConfirm({defaultPortConfirmationValue: false}); // false means custom, but port config is done
  }

  const { recording, ata } =  confirmation || {};

  return (
    <Modal size="lg" style={{ maxWidth: '900px' }} isOpen={isOpen}>
      <ModalHeader className="edit-number-port">
        Edit Number
        <Row>
          <Label for="enabled" sm={4}>
            Assign New Number
          </Label>
          <Col sm={3} style={{ marginTop: '8px' }}>
            <Toggle value={false} />
          </Col>
          <Label for="enabled" sm={4}>
            Port Number
          </Label>
        </Row>
      </ModalHeader>
      <ModalBody>
        <EditBoxNumber
          vmail={vmail}
          toggleMode
          onRemoveNumber={onRemoveNumber}
          updatePort={updatePort}
          selectRoute={selectRoute}
          gateways={gateways}
          boxDetails={boxDetails}
          updateTrunkSelection={updateTrunkSelection}
          onTrunckSelection={onTrunckSelection}
          setInbandRouting={setInbandRouting}
        />
      </ModalBody>
      <ModalFooter>
        {(user.role === 'superAdmin' ||
          user.role === 'companyGroupAdmin' ||
          user.role === 'supportEngineer' ||
          (user.role === 'admin' && type === 'dialout') ||
          (user.role === 'enterpriseAdmin' && type === 'dialout'))
          ? (
          <>
            <Button color="secondary" outline onClick={onCancel}>
              Cancel
            </Button>{' '}
            <Button
              color="primary"
              disabled={!!boxToBoxHuntInvalid || needsNewLineType}
              onClick={handleSave}
            >
              Save
            </Button>
          </>
        ) : (
          <Button color="secondary" onClick={onCancel}>
            Close
          </Button>
        )}
      </ModalFooter>
      <WarningModal
        isOpen={Boolean(recording || ata)}
        onConfirm={onWarningConfirm}
        title="Warning"
        onCancel={() => setConfirmation()}
        body={recording || ata}
      />
      {defaultPortConfirmationModal && <WarningModal
        isOpen={defaultPortConfirmationModal}
        onConfirm={() => onDefaultPortResponse(true)} // in case of use default values
        title="Warning"
        onCancel={() => onDefaultPortResponse(false)} // in case of use custom values
        body={<div>This port does not have a defined value in My.EPIK. Please choose one of the following options to continue:<br/><br/><ul><li><strong>Default:</strong> Assigns the standard value for this port type.</li><li><strong>Custom:</strong> Uses the current values configured in My.EPIK.</li></ul></div>}
        yesButtonText = "Default"
        noButtonText = "Custom"
        loadingCancel={loadingCustom}
        hardClose={()=> {
          setDefaultPortConfirmationModal(false);
          setLoadingCustom(false);
        }}
      />}
    </Modal>
  );
};

const mapStateToProps = state => ({
  company: state.UIState.numbers.editNumber.company,
  type: state.UIState.numbers.editNumber.type,
  onlyEfax: !!state.UIState.numbers.editNumber.onlyEfax,
  boxToBoxHuntInvalid: !!state.UIState.numbers.editNumber.boxToBoxHuntInvalid,
  user: state.AppState.user,
  testStatusFromStore:state.UIState?.epikBoxes?.alarmTestPass?.testStatus,
  selectedPort: state.UIState.epikBoxDetails.selectedPort,
});

const mapDispatchToProps = dispatch => ({
  setPortConfigModalSource: (source) => dispatch(setPortConfigModalSource(source)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditBoxNumberModal);
